import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Prolongatie, {
  isVisible: (settings: EnvironmentSettings) =>
    !settings.isMaatschappij || settings.isInterneGebruiker,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Prolongatie,
    title: 'Prolongatie',
    url: '/net/report/prolongatieoverzicht',
    iconclass: 'fas fa-arrows-rotate',
  }),
});
